/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Stakeholder', 'model/AutomatedSourceGeneratedNews', 'model/BingCognitiveItem', 'model/StakeholderReport', 'model/StakeholderReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/Stakeholder'), require('../model/AutomatedSourceGeneratedNews'), require('../model/BingCognitiveItem'), require('../model/StakeholderReport'), require('../model/StakeholderReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.Stakeholder, root.ForStractionServiceApi.AutomatedSourceGeneratedNews, root.ForStractionServiceApi.BingCognitiveItem, root.ForStractionServiceApi.StakeholderReport, root.ForStractionServiceApi.StakeholderReportPaginationSlice);
  }
}(this, function(ApiClient, Stakeholder, AutomatedSourceGeneratedNews, BingCognitiveItem, StakeholderReport, StakeholderReportPaginationSlice) {
  'use strict';

  /**
   * Stakeholder service.
   * @module api/StakeholderApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderApi. 
   * @alias module:api/StakeholderApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderAddPut operation.
     * @callback module:api/StakeholderApi~stakeholderAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/Stakeholder} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.setupSources  (default to false)
     * @param {module:api/StakeholderApi~stakeholderAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'setupSources': opts['setupSources']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Stakeholder/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderDeleteGet operation.
     * @callback module:api/StakeholderApi~stakeholderDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/StakeholderApi~stakeholderDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling stakeholderDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Stakeholder/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderEditPut operation.
     * @callback module:api/StakeholderApi~stakeholderEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/Stakeholder} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.setupSources  (default to false)
     * @param {module:api/StakeholderApi~stakeholderEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderEditPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'setupSources': opts['setupSources']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Stakeholder/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderGetAutomatedSourcesPreviewGet operation.
     * @callback module:api/StakeholderApi~stakeholderGetAutomatedSourcesPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AutomatedSourceGeneratedNews>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getAutomatedSourcesPreview
     * @param {String} _4SAPIAppID 
     * @param {String} businessID 
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {module:api/StakeholderApi~stakeholderGetAutomatedSourcesPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AutomatedSourceGeneratedNews>}
     */
    this.stakeholderGetAutomatedSourcesPreviewGet = function(_4SAPIAppID, businessID, startDate, endDate, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderGetAutomatedSourcesPreviewGet";
      }

      // verify the required parameter 'businessID' is set
      if (businessID == undefined || businessID == null) {
        throw "Missing the required parameter 'businessID' when calling stakeholderGetAutomatedSourcesPreviewGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling stakeholderGetAutomatedSourcesPreviewGet";
      }

      // verify the required parameter 'endDate' is set
      if (endDate == undefined || endDate == null) {
        throw "Missing the required parameter 'endDate' when calling stakeholderGetAutomatedSourcesPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'businessID': businessID,
        'startDate': startDate,
        'endDate': endDate
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [AutomatedSourceGeneratedNews];

      return this.apiClient.callApi(
        '/Stakeholder/getAutomatedSourcesPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderGetNewsPreviewGet operation.
     * @callback module:api/StakeholderApi~stakeholderGetNewsPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BingCognitiveItem>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getNewsPreview
     * @param {String} _4SAPIAppID 
     * @param {Integer} stakeholderID 
     * @param {Integer} strictnessLevel 
     * @param {String} brandNames 
     * @param {Boolean} newsSearch 
     * @param {Boolean} webSearch 
     * @param {Boolean} includeEnglishMarket 
     * @param {Integer} maxItems 
     * @param {module:api/StakeholderApi~stakeholderGetNewsPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BingCognitiveItem>}
     */
    this.stakeholderGetNewsPreviewGet = function(_4SAPIAppID, stakeholderID, strictnessLevel, brandNames, newsSearch, webSearch, includeEnglishMarket, maxItems, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'stakeholderID' is set
      if (stakeholderID == undefined || stakeholderID == null) {
        throw "Missing the required parameter 'stakeholderID' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'strictnessLevel' is set
      if (strictnessLevel == undefined || strictnessLevel == null) {
        throw "Missing the required parameter 'strictnessLevel' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'brandNames' is set
      if (brandNames == undefined || brandNames == null) {
        throw "Missing the required parameter 'brandNames' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'newsSearch' is set
      if (newsSearch == undefined || newsSearch == null) {
        throw "Missing the required parameter 'newsSearch' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'webSearch' is set
      if (webSearch == undefined || webSearch == null) {
        throw "Missing the required parameter 'webSearch' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'includeEnglishMarket' is set
      if (includeEnglishMarket == undefined || includeEnglishMarket == null) {
        throw "Missing the required parameter 'includeEnglishMarket' when calling stakeholderGetNewsPreviewGet";
      }

      // verify the required parameter 'maxItems' is set
      if (maxItems == undefined || maxItems == null) {
        throw "Missing the required parameter 'maxItems' when calling stakeholderGetNewsPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'stakeholderID': stakeholderID,
        'strictnessLevel': strictnessLevel,
        'brandNames': brandNames,
        'newsSearch': newsSearch,
        'webSearch': webSearch,
        'includeEnglishMarket': includeEnglishMarket,
        'maxItems': maxItems
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [BingCognitiveItem];

      return this.apiClient.callApi(
        '/Stakeholder/getNewsPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderLoadAllGet operation.
     * @callback module:api/StakeholderApi~stakeholderLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/StakeholderApi~stakeholderLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderReport>}
     */
    this.stakeholderLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderReport];

      return this.apiClient.callApi(
        '/Stakeholder/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderLoadGet operation.
     * @callback module:api/StakeholderApi~stakeholderLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} stakeholderID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/StakeholderApi~stakeholderLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderReport}
     */
    this.stakeholderLoadGet = function(_4SAPIAppID, stakeholderID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderLoadGet";
      }

      // verify the required parameter 'stakeholderID' is set
      if (stakeholderID == undefined || stakeholderID == null) {
        throw "Missing the required parameter 'stakeholderID' when calling stakeholderLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'stakeholderID': stakeholderID,
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderReport;

      return this.apiClient.callApi(
        '/Stakeholder/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderProcessDailyNewsChangesForAllGet operation.
     * @callback module:api/StakeholderApi~stakeholderProcessDailyNewsChangesForAllGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * processDailyNewsChangesForAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/StakeholderApi~stakeholderProcessDailyNewsChangesForAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderProcessDailyNewsChangesForAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderProcessDailyNewsChangesForAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Stakeholder/processDailyNewsChangesForAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderProcessInitialNewsSearchPut operation.
     * @callback module:api/StakeholderApi~stakeholderProcessInitialNewsSearchPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * processInitialNewsSearch
     * @param {String} _4SAPIAppID 
     * @param {module:model/Stakeholder} body 
     * @param {module:api/StakeholderApi~stakeholderProcessInitialNewsSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderProcessInitialNewsSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderProcessInitialNewsSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderProcessInitialNewsSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Stakeholder/processInitialNewsSearch', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderSearchSlicePut operation.
     * @callback module:api/StakeholderApi~stakeholderSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/Stakeholder} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StakeholderApi~stakeholderSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderReportPaginationSlice}
     */
    this.stakeholderSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderReportPaginationSlice;

      return this.apiClient.callApi(
        '/Stakeholder/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderSetupNewsSourcesPut operation.
     * @callback module:api/StakeholderApi~stakeholderSetupNewsSourcesPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setupNewsSources
     * @param {String} _4SAPIAppID 
     * @param {module:model/Stakeholder} body 
     * @param {module:api/StakeholderApi~stakeholderSetupNewsSourcesPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderSetupNewsSourcesPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderSetupNewsSourcesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderSetupNewsSourcesPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Stakeholder/setupNewsSources', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
